import { ExtendedRawUserProfile } from 'hooks/useIdentifyAnalytics/types';
import { PianoUser } from 'types/piano';
import { RIVT_ROLES } from 'lib/constants';

import type {
  HeaderUserData,
  HeaderUserProfile,
  FooterUserData,
  FooterUserProfile
} from './types';

/**
 * @deprecated Use `profileMapFactory` instead.
 */
export const legacyHeaderProfileMapFactory = (
  RIVTProfile: ExtendedRawUserProfile
): HeaderUserData['profileMap'] => {
  const mainProfileHasName = RIVTProfile.first_name && RIVTProfile.last_name;
  const mainProfileDisplayname = mainProfileHasName
    ? RIVTProfile.first_name.concat(' ').concat(RIVTProfile.last_name)
    : RIVTProfile.username;

  const mainProfile: HeaderUserProfile = {
    avatarURL: RIVTProfile.avatar_url,
    displayName: mainProfileDisplayname,
    /**
     * @todo Enable email verification feature in header
     * https://linear.app/outside/issue/UA-1481/[activity-feed]-enable-email-verification-feature-in-header
     */
    username: RIVTProfile.username,
    uuid: RIVTProfile.uuid,
    type: 'user'
  };

  // Map to key-value Iterable for Map constructor
  return new Map([[mainProfile.uuid, mainProfile]]);
};

/**
 * @deprecated Use `profileMapFactory` instead.
 */
export const legacyFooterProfileMapFactory = (
  RIVTProfile: ExtendedRawUserProfile,
  pianoUser: PianoUser
): FooterUserData['profileMap'] => {
  const mainProfileHasName = RIVTProfile.first_name && RIVTProfile.last_name;
  const mainProfileDisplayname = mainProfileHasName
    ? RIVTProfile.first_name.concat(' ').concat(RIVTProfile.last_name)
    : RIVTProfile.username;

  const isOutsidePlus = pianoUser.roles.includes(
    RIVT_ROLES.ActivePassFull || RIVT_ROLES.Oplus
  );

  const mainProfile: FooterUserProfile = {
    avatarURL: RIVTProfile.avatar_url,
    displayName: mainProfileDisplayname,
    /**
     * @todo Enable email verification feature in header
     * https://linear.app/outside/issue/UA-1481/[activity-feed]-enable-email-verification-feature-in-header
     */
    isEmailVerified: true,
    username: RIVTProfile.username,
    uuid: RIVTProfile.uuid,
    isOutsidePlus
  };

  // Map to key-value Iterable for Map constructor
  return new Map([[mainProfile.uuid, mainProfile]]);
};
